import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetClaimsHousingStocksFilterOptions = () => axios.get(`${apiPaths.claimsBase}/housing-stocks`);

const onGetClaimsInsuredRisksFilterOptions = (params) => axios.get(`${apiPaths.claimsBase}/insured-risks`, { params });

const onGetClaimsInsuredRiskTypesFilterOptions = () => axios.get(`${apiPaths.claimsBase}/insured-risk-types`);

const onGetPoliciesHousingStocksFilterOptions = () => axios.get(`${apiPaths.policiesBase}/housing-stocks`);

const onGetPoliciesInsuranceOrganizationsFilterOptions = (params) =>
  axios.get(`${apiPaths.policiesBase}/insurance-organizations`, { params });

const onGetPoliciesCustomFieldsFilterOptions = (params) =>
  axios.get(`${apiPaths.policiesBase}/custom-fields`, { params });

const onGetPoliciesInsuredRiskTypesFilterOptions = (params) =>
  axios.get(`${apiPaths.policiesBase}/insured-risk-types`, { params });

const onGetPoliciesInsuredRisksFilterOptions = (params) =>
  axios.get(`${apiPaths.policiesBase}/insured-risks`, { params });

const onGetRisksHousingStocksFilterOptions = () => axios.get(`${apiPaths.risksBase}/housing-stocks`);

const onGetRisksOrganizationsFilterOptions = () => axios.get(`${apiPaths.risksBase}/organizations`);

const onGetRisksCompanyCodesFilterOptions = () => axios.get(`${apiPaths.risksBase}/company-codes`);

const onGetRisksCompanyLabelsFilterOptions = () => axios.get(`${apiPaths.risksBase}/company-labels`);

const onGetRisksEconomicUnitsFilterOptions = () => axios.get(`${apiPaths.risksBase}/economic-units`);

const onGetClaimsCreatedByOrganizationsFilterOptions = () =>
  axios.get(`${apiPaths.claimsBase}/created-by-organizations`);

const onGetClaimsOrganizationsWithAccessFilterOptions = () =>
  axios.get(`${apiPaths.claimsBase}/organizations-with-access`);

export {
  onGetClaimsHousingStocksFilterOptions,
  onGetClaimsInsuredRisksFilterOptions,
  onGetClaimsInsuredRiskTypesFilterOptions,
  onGetClaimsCreatedByOrganizationsFilterOptions,
  onGetClaimsOrganizationsWithAccessFilterOptions,
  onGetPoliciesHousingStocksFilterOptions,
  onGetPoliciesInsuranceOrganizationsFilterOptions,
  onGetPoliciesCustomFieldsFilterOptions,
  onGetPoliciesInsuredRiskTypesFilterOptions,
  onGetPoliciesInsuredRisksFilterOptions,
  onGetRisksHousingStocksFilterOptions,
  onGetRisksOrganizationsFilterOptions,
  onGetRisksCompanyCodesFilterOptions,
  onGetRisksCompanyLabelsFilterOptions,
  onGetRisksEconomicUnitsFilterOptions
};
